/** @format */
import React, {useState} from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { replaceUnderscoresWithSpaces } from "utils/strings";
import loginbg from "images/Login.png";
import { ReactComponent as EnvIcon } from "images/svg/enveloope.svg";
import AuthHeader from "./components/auth-header";
import { useAccountCompletionMutation } from "store/services/authAPI";
import { ReactComponent as CheckEmailIcon } from "images/svg/check-email.svg";
import { ReactComponent as PadlockIcon } from "images/svg/padlock.svg";

function CompleteRegistration() {
  const [completeReg, { isLoading: requesting }] = useAccountCompletionMutation();
  const [showCheckEmail, setShowCheckEmail] = useState(false);
  const [isShown, setIsSHown] = useState(false);

  const togglePassword = () => {
    setIsSHown((isShown) => !isShown);
  };
  
  const handleSubmit = async (values) => {
    await completeReg({
      email: values.email,
      password: values.password 
    })
      .unwrap()
      .then((data) => {
        setShowCheckEmail(true);
      })
      .catch((error) => {
        const errorText = error?.data?.detail;
        const btnText = "Try Again";

        Swal.fire({
          title: error?.data?.code
            ? replaceUnderscoresWithSpaces(error?.data?.code)
            : "Error Occured",
          iconHtml: ` <i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>`,
          text: errorText || "Error Occured",
          showCloseButton: true,
          customClass: {
            icon: "no-border",
          },
          cancelButtonText: btnText,
          showConfirmButton: false,
          showCancelButton: true,
        });
      });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: ""
    },
    validationSchema: Yup.object().shape({
      email: Yup.string().email().required("Email is required"),
      password: Yup.string()
        .required("Password is required")
        .min(6, "Password must be at least 6 characters"),
      confirmPassword: Yup.string()
        .required("Please confirm your password")
        .oneOf([Yup.ref('password'), null], 'Passwords must match')
    }),
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  const isFormComplete = formik.dirty && formik.isValid;

  return (
    <>
      <div
        className="login-main-page auth-page"
        style={{
          background: "url(" + loginbg + ")",
          backgroundSize: "contain",
        }}
      >
        <AuthHeader />

        <div className="login-wrapper w-100 mt-4">
          <div className="container h-100">
            <div className="row h-100 align-items-center justify-content-center">
              <div className="col-xl-6 mt-3">
                {showCheckEmail ? (
                  <div className="card auth-card">
                    <div className="card-body p-0">
                      <div className="row m-0">
                        <div className="col-xl-12 col-md-12">
                          <div className="sign-in-your text-center">
                            <CheckEmailIcon className="mb-3"/>
                            <div className="">
                              <h4 className="registration-heading mb-3">
                                Check your mailbox
                              </h4>
                              <p className="registration-title ">
                                We've sent you an email buddy, please <br />
                                check your mailbox for an email from 3MTT
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="card auth-card">
                    <div className="card-body p-0">
                      <div className="row m-0">
                        <div className="col-xl-12 col-md-12">
                          <div className="sign-in-your">
                            <h4 className="fs-20 font-w800 text-black">
                              Complete Registration
                            </h4>

                            <p className="mb-2 welcome">
                              Don't miss out, finish up and get started!                            
                            </p>

                            <form
                              className="form mt-4"
                              onSubmit={formik.handleSubmit}
                            >
                              <div className="mb-3">
                                <label className="mb-1">
                                  <strong>Email Address</strong>
                                </label>

                                <div className="password__container">
                                  <EnvIcon />
                                  <input
                                    type="email"
                                    className="form-control"
                                    id="email"
                                    name="email"
                                    placeholder="e.g. example@domainname.com"
                                    {...formik.getFieldProps("email")}
                                  />
                                </div>

                                {formik.touched.email && formik.errors.email ? (
                                  <div className="text-danger mt-2 fs-12">
                                    {formik.errors.email}
                                  </div>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <label className="mb-1">
                                  <strong>Password</strong>
                                </label>
                                <div className="password__container">
                                  <PadlockIcon />
                                  <input
                                    type={isShown ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    className="form-control"
                                    placeholder="Enter Password"
                                    {...formik.getFieldProps("password")}
                                  />
                                  <button 
                                    type="button" 
                                    onClick={togglePassword}
                                    className="btn btn-link p-0"
                                  >
                                    <div className="icon">
                                      {isShown ? (
                                        <i className="bi bi-eye"></i>
                                      ) : (
                                        <i className="bi bi-eye-slash"></i>
                                      )}
                                    </div>
                                  </button>
                                </div>
                                {formik.touched.password && formik.errors.password ? (
                                  <div className="text-danger mt-2 fs-12">
                                    {formik.errors.password}
                                  </div>
                                ) : null}
                              </div>

                              <div className="mb-3">
                                <label className="mb-1">
                                  <strong>Confirm Password</strong>
                                </label>
                                <div className="password__container">
                                  <PadlockIcon />
                                  <input
                                    type={isShown ? "text" : "password"}
                                    id="confirmPassword"
                                    name="confirmPassword"
                                    className="form-control"
                                    placeholder="Confirm Password"
                                    {...formik.getFieldProps("confirmPassword")}
                                  />
                                  <button 
                                    type="button" 
                                    onClick={togglePassword}
                                    className="btn btn-link p-0"
                                  >
                                    <div className="icon">
                                      {isShown ? (
                                        <i className="bi bi-eye"></i>
                                      ) : (
                                        <i className="bi bi-eye-slash"></i>
                                      )}
                                    </div>
                                  </button>
                                </div>
                                {formik.touched.confirmPassword && formik.errors.confirmPassword ? (
                                  <div className="text-danger mt-2 fs-12">
                                    {formik.errors.confirmPassword}
                                  </div>
                                ) : null}
                              </div>

                              <div className="text-center">
                                <button
                                  type="submit"
                                  className="btn btn-primary btn-block"
                                  disabled={!isFormComplete || requesting}
                                >
                                  {requesting ? (
                                    <>
                                      <span 
                                        className="spinner-border spinner-border-sm me-2" 
                                        role="status" 
                                        aria-hidden="true"
                                      ></span>
                                      Processing...
                                    </>
                                  ) : (
                                    "Proceed"
                                  )}
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CompleteRegistration;